import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import ChoThanhToanApi from "../../../../service/TichHopBank/choThanhToanApi";
import { pushNotification } from "utils/notifications";
export const ModalXoa = ({ toggleModal, isModalVisible, item, onSearch }) => {

  const [bDisable, setDisableButton] = useState(false);
  const DeleteBank = () => {
    setDisableButton(true);
    ChoThanhToanApi.deleteChoThanhToan({ idChoThanhToan: item.Id }).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        onSearch();
        toggleModal();
        pushNotification(
          "Thao tác thành công",
          "success",
          "TOP_CENTER",
          2000
        );
      } else {
        pushNotification(
          response.data,
          "error",
          "TOP_CENTER",
          2000
        )
      }
    });

  }
  useEffect(() => {
  }, []);
  return (
    <Modal
      show={isModalVisible}
      size="modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left">
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          Xác nhận xóa
        </h4>
        <button type="button" className="close-popup-new" onClick={toggleModal}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="body-detail-bc" style={{ color: "black" }}>
          <div class="form-money-2" style={{ marginBottom: "5px" }}>
            <div class="row">
              <div class="col-sm-12">
                <span style={{ color: "color7" }}>Bạn có chắc chắn muốn xóa không?</span>
              </div>

            </div>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <div class="from-button-modal">
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6 text-right">
              <button className="btn btn-new-main btn-checknew" onClick={e => DeleteBank()} disabled={bDisable}>
                <span className="btn-icon-left">
                  <i className="mdi mdi-check"></i>
                </span>
                Xác nhận
              </button>
              <button
                type="button"
                class="btn btn-new-main btn-closenew"
                onClick={toggleModal}
                style={{ marginLeft: "5px" }}
              >
                <span class="btn-icon-left">
                  <i class="mdi mdi-close"></i>
                </span>
                Đóng
              </button>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
